import { createEvent, attach, scopeBind, sample } from "effector";
import "@apollo/client";
import { storify } from "../lib/storify.mjs";
import { setupSubscription } from "../setup_subscription.mjs";
function watchQuery(query, {
  client = query.meta.client,
  enabled: $enabled = query.$succeeded,
  optimistic = true
} = {}) {
  const name = `${query.meta.name}.watch`;
  const options = { query: query.meta.document, optimistic };
  const $client = storify(client, { name: `${name}.client`, sid: `apollo.${name}.$client` });
  const updated = createEvent({ name: `${name}.updated` });
  const subscribeFx = attach({
    name: `${name}.subscribe`,
    source: { variables: query.__.$variables, client: $client },
    effect({ variables, client: client2 }) {
      const callback = scopeBind(updated, { safe: true });
      return client2.cache.watch({ ...options, variables, callback });
    }
  });
  const maskFx = attach({
    name: `${name}.mask`,
    source: { client: $client },
    effect: ({ client: client2 }, data) => {
      const manager = client2.queryManager;
      return manager.maskOperation({ data, document: query.meta.document, id: name });
    }
  });
  const ready = sample({ clock: $enabled, filter: (enabled) => enabled });
  const teardown = sample({ clock: $enabled, filter: (enabled) => !enabled });
  const setup = sample({
    clock: [ready, query.finished.finally, query.__.$variables],
    filter: $enabled,
    fn: () => void 0
  });
  sample({
    clock: updated,
    filter: ({ complete }) => Boolean(complete),
    fn: ({ result }) => result,
    target: maskFx
  });
  sample({
    clock: maskFx.doneData,
    target: query.__.push
  });
  setupSubscription({ subscribe: subscribeFx, setup, teardown, name });
}
export {
  watchQuery
};
//# sourceMappingURL=watcher.mjs.map
